const chartTypeOptions = {
  line: 'Line',
  bar: 'Bar',
};

export default chartTypeOptions;
